import React, { useState } from "react";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

import ProtectedFilePreview from "./ProtectedFilePreview";
import "./estimateClaims.css";

/**
 * A protected file behind a "Show … / Hide …" toggle, closed unless
 * `defaultOpen`. The preview mounts only once opened, so the file isn't
 * fetched until someone asks to read it — a long results page no longer
 * starts with a 560px claim form in the way.
 */
export default function CollapsibleFilePreview({
  url,
  fileName,
  label,
  height,
  showText = "Show file",
  hideText = "Hide file",
  defaultOpen = false,
}) {
  const [open, setOpen] = useState(!!defaultOpen);
  return (
    <div className={"est-collapsible-file" + (open ? " is-open" : "")}>
      <button
        type="button"
        className="est-view-toggle est-collapsible-file-toggle"
        aria-expanded={open}
        onClick={function () { setOpen(!open); }}
      >
        {open ? hideText : showText}
        {open ? <UpOutlined /> : <DownOutlined />}
      </button>
      {open ? <ProtectedFilePreview url={url} fileName={fileName} label={label} height={height} /> : null}
    </div>
  );
}
